'use client';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { useCallback, useEffect, useState } from 'react';
import ProfileAuthModal, { ProfileAuthMobile } from './profile/auth';
import { useProfile } from './profile';
import ProfileModal, { ProfileModalMobile } from './profile/modal';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FolderIcon from '@mui/icons-material/Folder';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import AutoAwesomeMotionRoundedIcon from '@mui/icons-material/AutoAwesomeMotionRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import { guestLimit } from '../guestLimit';

import topStyles from './top.module.css'

// import LoginIcon from '@mui/icons-material/Login'

type TopProps = {
  searchText?: string
  searchOff?: true
  mangaUrl?: string
}

export default function TopWrapper (props: TopProps) {
  const profile = useProfile();
  const [ value, setValue ] = useState<string>('');

  const getDefaultValue = useCallback(() => {
    switch (document.location.pathname) {
      case '/':
        return 'home';
      case '/catalog':
        return 'catalog';
      default:
        return '';
    }
  }, []);

  useEffect(() => {
    setValue(getDefaultValue());
  }, []);

  useEffect(() => {
    if (profile.isOpenAuthModal || profile.isOpenProfileModal) {
      if (value !== 'profile') setValue('profile');
    } else {
      if (value === 'profile') setValue(getDefaultValue());
    }
  }, [profile.isOpenAuthModal, profile.isOpenProfileModal]);

  useEffect(() => {
    console.log('Change status on ' + (profile.isMobile ? 'mobile' : 'desctop'));
    const padding = profile.isMobile ? ((window as any).mobilemenu?.clientHeight ?? 0) + 20 : 0;
    const r = document.querySelector('html');
    r?.style.setProperty('padding-bottom', padding + 'px');
  }, [profile.isMobile]);

  if (profile.isMobile) {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      if (newValue === 'home') {
        document.location.href = '/';
        return;
      }
      if (newValue === 'catalog') {
        document.location.href = '/catalog';
        return;
      }
      if (newValue === 'profile') {
        if (profile.data.data) {
          if (!profile.isOpenProfileModal) window.gtag('event', 'popup_profile');
          profile.setOpenProfileModal(!profile.isOpenProfileModal);
        } else {
          if (!profile.isOpenAuthModal) window.gtag('event', 'popup_auth');
          profile.needOpenProfileAfterAuth(!profile.isOpenAuthModal);
          profile.setOpenAuthModal(!profile.isOpenAuthModal);
        }
      } else if (newValue) {
        if (profile.isOpenProfileModal) profile.setOpenProfileModal(false);
        if (profile.isOpenAuthModal) profile.setOpenAuthModal(false);
      }
      setValue(newValue === value ? getDefaultValue() : newValue);
    };

    const isActiveSubscription = profile.downloadLimit ? BigInt(profile.downloadLimit.left) > guestLimit : false;

    return <Paper sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1201,
      background: 'white',
      zoom: `max(${650 / (profile.screenWidth ?? 650)}, 1)`,
      // ...(
      //   process.env.THEME === 'HNY' ? {
      //     'div': {
      //       backgroundColor: '#b30000 !important',
      //     },
      //     'div > button': {
      //       color: 'white !important',
      //     }
      //   } : {}
      // )
    }} elevation={3}>
      <BottomNavigation id='mobilemenu' value={value} onChange={handleChange} showLabels style={{ justifyContent: 'space-between' }}>
        <BottomNavigationAction
          label="RuManga"
          value="home"
          icon={<WebRoundedIcon />}
        />
        <BottomNavigationAction
          label="Каталог"
          value="catalog"
          icon={<AutoAwesomeMotionRoundedIcon />}
        />
        <BottomNavigationAction
          label="Поиск"
          value="search"
          icon={value === 'search' ? <ExpandMoreRoundedIcon /> : (props.searchText ? <ManageSearchRoundedIcon /> : <SearchRoundedIcon />)}
        />
        <BottomNavigationAction
          style={
            profile.data.data ?
              {
                backgroundImage: isActiveSubscription ? 'url(/manga_btn2.png)' : 'url(/manga_btn1.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
                fontWeight: 'bold',
                textShadow: '0px 0px 10px black',
                borderTopLeftRadius: '25px',
                borderBottomLeftRadius: '25px',
              }
            :
              {}
          }
          label="Профиль"
          value="profile"
          icon={value === 'profile' ? <ExpandMoreRoundedIcon /> : <MenuIcon />}
        />
      </BottomNavigation>
      {
        value !== 'profile' && profile.profileMainData?.notifications.new ?
          <div className={topStyles.mobileNotificationBox} onClick={() => {
            setValue('profile');
            profile.setOpenProfileModal(true);
          }}><NotificationsActiveRoundedIcon style={{ fontSize: '18px' }} /> {profile.profileMainData?.notifications.new}</div>
        : <></>
      }
      <ProfileAuthMobile isOpen={profile.isOpenAuthModal} handleClose={() => profile.setOpenAuthModal(false)} />
      <ProfileModalMobile isOpen={!!profile.isOpenProfileModal} section={typeof profile.isOpenProfileModal !== 'boolean' ? profile.isOpenProfileModal : undefined} handleClose={() => profile.setOpenProfileModal(false)} />
      <SearchDrawer isOpen={value === 'search'} text={props.searchText} handleClose={() => setValue(getDefaultValue())} />
    </Paper>
  } else {
    return <Stack
      width="100%"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={3}
      style={{ marginBottom: '2ch' }}
    >
      <Box flexGrow={1}>
        <h1><a href="/">RuManga</a> <Button href='/catalog' title='Каталог' variant='outlined' color='inherit' size='small'><AutoAwesomeMotionRoundedIcon /></Button></h1>
      </Box>
      { !props.searchOff ?
        <Box>
          <Paper
            component="form"
            action={'/search'}
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
          >
            <InputBase
              name='a'
              sx={{ ml: 1, flex: 1 }}
              placeholder="Найти мангу"
              inputProps={{ 'aria-label': 'Поиск тайтлов' }}
              defaultValue={props.searchText}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Box>
      : '' }
      <Box>
        <ProfileBtn />
      </Box>
    </Stack>
  }
}

function ProfileBtn () {
  const profile = useProfile();

  const clb = () => {
    if (profile.data.data) {
      window.gtag('event', 'popup_profile');
      profile.setOpenProfileModal(true);
    } else {
      window.gtag('event', 'popup_auth');
      profile.needOpenProfileAfterAuth(true);
      profile.setOpenAuthModal(true);
    }
  }

  const isActiveSubscription = profile.downloadLimit ? BigInt(profile.downloadLimit.left) > guestLimit : false;

  return <>
    <div className={topStyles.profileBtn + ' ' + (profile.profileMainData?.notifications.new ? topStyles.hasNotifications : '')}>
      {
        profile.data.data ?
          isActiveSubscription ?
            <Button
              variant="contained"
              color="warning"
              onClick={clb}
              style={{
                backgroundImage: 'url(/manga_btn2.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
                fontWeight: 'bold',
                textShadow: '0px 0px 10px black',
                // ...( process.env.THEME === 'HNY' ? { boxShadow: '0px 0px 4px 4px #b30000' } : {} )
              }}
            >Мой профиль</Button>
          :
            <Button
              variant="contained"
              color="warning"
              onClick={clb}
              style={{
                backgroundImage: 'url(/manga_btn1.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
                fontWeight: 'bold',
                textShadow: '0px 0px 10px black',
                // ...( process.env.THEME === 'HNY' ? { boxShadow: '0px 0px 4px 4px #b30000' } : {} )
              }}
            >Мой профиль</Button>
        :
          <Button
            variant="contained"
            // color={ process.env.THEME === 'HNY' ? "error" : undefined }
            onClick={clb}
          >Мой профиль</Button>
      }
      {
        profile.profileMainData?.notifications.new ?
          <div className={topStyles.notificationCounter}><NotificationsActiveRoundedIcon style={{ fontSize: '18px' }} /> {profile.profileMainData.notifications.new}</div>
        : <></>
      }
    </div>
    
    <ProfileAuthModal isOpen={profile.isOpenAuthModal} handleClose={() => profile.setOpenAuthModal(false)} />
    <ProfileModal isOpen={!!profile.isOpenProfileModal} section={typeof profile.isOpenProfileModal !== 'boolean' ? profile.isOpenProfileModal : undefined} handleClose={() => profile.setOpenProfileModal(false)} />
  </>
}

function SearchDrawer (props: { isOpen: boolean, handleClose: any, text?: string }) {
  return <Drawer
    anchor='bottom'
    open={props.isOpen}
    onClose={props.handleClose}
    PaperProps={{
      sx: {
        paddingBottom: ((window as any).mobilemenu?.clientHeight ?? 0) + 40 + 'px',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderTop: '5px solid #0288d1',
        paddingTop: '10px',
      }
    }}
  >
    <Box padding={'24px 24px'} sx={{ zoom: `max(${650 / window.screen.availWidth}, 1)` }}>
      <Paper
        component="form"
        action={'/search'}
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
      >
        <InputBase
          name='a'
          sx={{ ml: 1, flex: 1 }}
          placeholder="Найти мангу"
          inputProps={{ 'aria-label': 'Поиск тайтлов' }}
          defaultValue={props.text}
        />
        <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
    </Box>
  </Drawer>
}